import React from 'react'
import AuthGuard from './AuthGuard';

const ManageSegment = React.lazy(() => import("../pages/SystemConfiguration/ManageSegment"));
const CreateAudience = React.lazy(() => import("../pages/SystemConfiguration/CreateAudienceSegment"));
const GeoIntel = React.lazy(() => import("../pages/GeoIntel"));

const AudienceRoutes = [
    {
        path: "targeting/createAudience",
        element: <AuthGuard><CreateAudience /></AuthGuard>
    },
    {
        path: "/targeting/editaudiencesegment/:id",
        element: <AuthGuard><CreateAudience /></AuthGuard>
    },
    {
        path: "audience/segments",
        element: <AuthGuard><ManageSegment /></AuthGuard>
    },
    {
        path: "audience/geointel",
        element: <AuthGuard><GeoIntel /></AuthGuard>
    },
]

export default AudienceRoutes;